export default __webpack_public_path__ + "static/media/impact-RTP.b010407b.webp";